import React, { createContext, useEffect, useState } from "react";
import logger from "../services/Logger";
import { IS_TEST } from "../consts";

// Create the context
export const TourContext = createContext();

// Create the provider component
export const TourProvider = ({ children }) => {
  // this is for testing
  const [tourInfo, setTourInfo] = useState(
    IS_TEST
      ? {
          consolidatedList: [
            {
              arrivalTime: "09:35",
              endLocationAddress: "10500 Nicolet Way, Austin, TX 78717, USA",
              startLocationAddress: "9414 N Lamar Blvd, Austin, TX 78753, USA",
              timeOnProperty: 15,
              commuteTimeToNextSite: 20,
            },
            {
              arrivalTime: "10:01",
              endLocationAddress: "11704 Tanglebriar Trail, Austin, TX 78750, USA",
              startLocationAddress: "10505 Nicolet Way, Austin, TX 78717, USA",
              timeOnProperty: 15,
              commuteTimeToNextSite: 11,
            },
            {
              arrivalTime: "10:20",
              endLocationAddress: "10503 Weller Dr, Austin, TX 78750, USA",
              startLocationAddress: "11704 Tanglebriar Trail, Austin, TX 78750, USA",
              timeOnProperty: 15,
              commuteTimeToNextSite: 4,
            },
            {
              arrivalTime: "10:37",
              endLocationAddress: "10518 Glass Mountain Trail, Austin, TX 78750, USA",
              startLocationAddress: "10503 Weller Dr, Austin, TX 78750, USA",
              timeOnProperty: 15,
              commuteTimeToNextSite: 2,
            },
            {
              arrivalTime: "10:59",
              endLocationAddress: "13301 N Hwy 183, Austin, TX 78750, USA",
              startLocationAddress: "10518 Glass Mountain Trail, Austin, TX 78750, USA",
              timeOnProperty: 15,
              commuteTimeToNextSite: 7,
            },
          ],
          startTime: "09:00",
          timeOnProperty: 15,
        }
      : []
  );

  useEffect(() => {
    logger.debug("This is tour info in the Tour context - ", tourInfo);
  }, [tourInfo]);

  return (
    <TourContext.Provider
      value={{
        tourInfo,
        setTourInfo,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};
